const TRANSLATE_MODAL = 'CAMPAIGNS_MAIN.CREATE_EDIT_CAMPAIGNS';
const TRANSLATE_MODAL_INPUTS = `${TRANSLATE_MODAL}.INPUTS_FORM`;

interface ICreateEditCampaignsProps {
  show: boolean;
  onClose: (value?: boolean) => void;
}

enum EStrategyOptionsName {
  MARKETING = 'Marketing',
  VENTAS = 'Ventas',
  REMARKETING = 'Remarketing',
  NURTURING = 'Nurturing',
  OTHER = 'Other',
}

interface IStrategyOptions {
  id: number;
  name: EStrategyOptionsName;
  value: string;
}

const STRATEGY_OPTIONS: IStrategyOptions[] = [
  {
    id: 1,
    name: EStrategyOptionsName.MARKETING,
    value: EStrategyOptionsName.MARKETING.toLowerCase(),
  },
  {
    id: 2,
    name: EStrategyOptionsName.VENTAS,
    value: EStrategyOptionsName.VENTAS.toLowerCase(),
  },
  {
    id: 3,
    name: EStrategyOptionsName.REMARKETING,
    value: EStrategyOptionsName.REMARKETING.toLowerCase(),
  },
  {
    id: 4,
    name: EStrategyOptionsName.NURTURING,
    value: EStrategyOptionsName.NURTURING.toLowerCase(),
  },
  {
    id: 5,
    name: EStrategyOptionsName.OTHER,
    value: EStrategyOptionsName.OTHER.toLowerCase(),
  },
];

enum MAX_MIN_LENGTH {
  MIN_LENGTH = 2,
  NAME_MAX = 60,
  OBJECTIVE_MAX = 150,
  OTHER_STRATEGY_MAX = 30,
}

interface IFormInput {
  name: string;
  type: boolean;
  objective: string;
  strategy: string;
  otherStrategy: string;
  date: string;
}

export {
  EStrategyOptionsName,
  MAX_MIN_LENGTH,
  STRATEGY_OPTIONS,
  TRANSLATE_MODAL,
  TRANSLATE_MODAL_INPUTS,
};
export type { ICreateEditCampaignsProps, IFormInput, IStrategyOptions };
